import Dictionary from '../components/dictionarypage/Dictionary';

const DictionaryPage = () => {
    return (
        <>
            <Dictionary />
        </>
    );
};

export default DictionaryPage;
